import ajax from "@/lib/ajax";
/**
 * 读取质控设定
 */
export async function GetQualityControlSetList() {
    let res = await ajax.get(`/api/services/app/PDQualityControlSet/GetQualityControlSetList`);
    return res.data.result;
}

/**
 * 新增质控设定
 * @param payload 
 */
export async function InsertQualityControlSet(payload: any) {
    let res = await ajax.post(`/api/services/app/PDQualityControlSet/InsertQualityControlSet`, payload);
    return res.data.result;
}
/**
 * 删除质控设定
 * @param id 质控设定编号
 */
export async function DeleteQualityControlSet(id: number) {
    let res = await ajax.delete(`/api/services/app/PDQualityControlSet/DeleteQualityControlSet?id=` + id);
    return res.data.result;
}
/**
 * 修改质控设定
 * @param payload
 */
export async function UpdateQualityControlSet(payload: any) {
    let res = await ajax.put(`/api/services/app/PDQualityControlSet/UpdateQualityControlSet`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdQualityControlManage/pdQualityControlSet/index.ts